import React from 'react';
import { RouteComponentProps } from 'react-router';

import { Paper, makeStyles, createStyles, Typography, Grid, Button, Divider } from '@material-ui/core';
import { green } from '@material-ui/core/colors';

import DaileonForm, { FormFields, DaileonFormButton } from '../../main/component/daileonForm';
import { CompatibleTextField } from '../../main/component/daileonCommonInput';
import Util from './../../main/service/util';
import SelectCheckBoxField from '../../main/component/selectCheckBoxField';
import ValidationService from '../../main/service/validationService';


const useStyles = makeStyles( theme => createStyles({
        paper: {
            padding: theme.spacing(1),
        },
        divider: {
            margin: theme.spacing(1,0,1,0),
        },
        addButton: {
            color: theme.palette.common.white,
            backgroundColor: green[500],
            '&:hover': {
                backgroundColor: green[600],
            },
        },
    }),
);

const CadastroNivel: React.FC<RouteComponentProps> = (props)=>{
    const classes = useStyles({});

    const initialValues = props.location.state;
    const editCode = initialValues && initialValues.id;

    const save = async (data:any)=>{
        const postData = {
            action: editCode?'update':'insert',
            id: editCode,
            ...data,
            acesso: data.acesso.map(val=>val.value),
        };
        const [,failed] = await Util.backendRequestHandled('auth/nivel','POST',postData,true,true,true);
        if(!failed){
            props.history.push('/nivel');
        }
    }

    //------- FORM ------------
    const formFields:FormFields = [
        {label: "Nome", name: "nome", defaultValue: "",
            type: CompatibleTextField, props:{},
            validation: ValidationService.required,
        },
        {label: "Acesso", name: "acesso", defaultValue: [],
            type: SelectCheckBoxField, props:{
                dataURI:"auth/acesso", dataPath: "acesso", optionLabelPath: "label", optionValuePath: "id",
                isSearchable: true,
            },
        },
    ]
    const formButtons:DaileonFormButton[] = [
        {label: "Reverter",
            props: {variant: "contained", color: "default"},
            action: async (form)=>{
                await form.clear();
            },
        },
        {label: "Salvar", isSubmit: true,
            props: {variant: "contained", color: "primary"},
            action: (form)=>{
                const allValid = form.validateAll();
                if(allValid){
                    const values = form.getValues();
                    save(values);
                } else {
                    form.highlightInvalid();
                }
            },
        },
    ]

    return <Paper className={classes.paper}>
            <Grid container direction='row' justify='space-between' alignItems='center'>
                <Typography variant='h5'>{editCode ? `Editando nível (cod. ${editCode})` : "Novo nível de acesso"}</Typography>
                <Button variant='contained' color='default' onClick={()=>props.history.goBack()}>Voltar</Button>
            </Grid>
            <Divider className={classes.divider}/>

            <DaileonForm
                fields={formFields}
                buttons={formButtons}
                initialValues={initialValues}
                />
        </Paper>;
}

export default CadastroNivel;